export const Props = () => ({
  //Объект видео
  data: {
    type: Object,
  },
});